<template>
  <div class="overflow: auto">
    <v-row class="ma-2 d-flex align-center">
      <v-col sm="4">
        <v-btn @click="$emit('back')" outlined>{{ $t("back_short") }}</v-btn>
      </v-col>
      <v-col sm="4" style>
        <h3 style="text-align: center">{{ $t("stem_size") }}</h3>
      </v-col>
      <v-col sm="4" />
    </v-row>
    <div class="mt-2" style="overflow: auto; max-height: 400px">
      <v-col cols="20" class="mt-0">
        <div class="d-flex align-end justify-center">
          <v-select v-model="stemSize.min" :items="stemOptions"  :style="'width: 150px'"  />
          <!-- <div class="d-flex align-end"><numeric-input :readonly="false" v-model.number="stemSize.min" @edit="onEdit($event, 'min')" /> {{ $t("size_label") }}</div> -->
          〜
          <div class="d-flex align-end">
            <v-select v-model="stemSize.max" :items="stemOptions" style="width: 65%" />
            <!-- <numeric-input :readonly="false" v-model.number="stemSize.max" @edit="onEdit($event, 'max')" />--> {{
                $t("size_label")
            }}
          </div>
        </div>
      </v-col>
    </div>
    <v-card-actions class="d-flex justify-center">
      <v-btn class="px-4" color="blue darken-1" outlined @click="clearModal">クリア</v-btn>
      <v-btn color="blue darken-1" depressed @click="$emit('click', { key: 'stem_size', value: stemSize })">決定</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import numericInput from "@/components/shared/numericInput.vue";
import { localeDate } from "@/plugins/i18n";

export default {
  components: {
    numericInput
  },
  props: {
    stem_size: {
      type: Object,
      default: () => ({
        min: 0,
        max: 0
      })
    }
  },
  data() {
    return {
      stemSize: {
        min: 0,
        max: 0
      }
    };
  },
  created() {
    this.stemSize.min = this.stem_size.min;
    this.stemSize.max = this.stem_size.max;
  },
  methods: {
    localeDate,
    clearModal() {
      this.stemSize.min = null;
      this.stemSize.max = null;
    },
    onEdit(e, key) {
      if (key === "min") this.stemSize.min = Number(e);
      if (key === "max") this.stemSize.max = Number(e);
    }
  },
  computed: {
    deliveryDateList() {
      return this.$store.state.searchQuery.delivery_date_list;
    },
    stemOptions() {
      return [10, 20, 30, 40, 50, 60, 70, 80, 90];
    },
  }
};
</script>
